export enum LocalStorageKey {
    Theme = "settings.theme",
    Scaling = "settings.scaling",
}
